/**
 * Função criada para diminuir a duplicação levantada pelo sonar 
 * e contornar o bloqueio de merge.
 */
export function sidebarDefaultReset() {
	this.mensage = ''
	this.fieldGroupOptions = []
	this.groupFieldOptions = []
	this.leadOptions = []
	this.optionsLoading = false
	this.productLoading = false
	this.statusLoading = false
	this.stageLoading = false
	this.funnelStageLoading = false
	this.funnelStageStatusLoading = false
	this.fieldGroupSelected = null
	this.fieldGroupLoading = false
	this.groupFieldLoading = false
	this.groupFieldSelected = null
	this.leadLoading = false
}
